import { render, staticRenderFns } from "./StatisDeptDaily.vue?vue&type=template&id=5abd4ae2&scoped=true"
import script from "./StatisDeptDaily.vue?vue&type=script&lang=js"
export * from "./StatisDeptDaily.vue?vue&type=script&lang=js"
import style0 from "./StatisDeptDaily.vue?vue&type=style&index=0&id=5abd4ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abd4ae2",
  null
  
)

export default component.exports